<template>
  <v-container class="view">
    <v-row justify="center" align="center" style="min-height:50vh">
      <v-col cols="12" sm="4">
        <h2 class="display-5 mt-3 mb-1 text-center">Confirm Reset Token</h2>
        <p class="sub-hero-text my-3 text-center">
          Please enter the OTP that was sent to you, typically a six
          alphanumeric digit
        </p>

        <small v-if="error" class="red--text lighten-3 px-2 small text-center">{{ errorMessage }}</small>

        <v-otp-input length="6" class="my-3" @finish="submit" v-model="otp" :disabled="loading"></v-otp-input>

        <v-overlay absolute :value="loading">
          <v-progress-circular indeterminate color="var(--yellow)"></v-progress-circular>
        </v-overlay>

        <v-btn type="button" class="
            text-lowercase text-grey  text-decoration-underline 
          " :disabled="counting" @click="startCountdown" plain small>
          Didn&apos;t get an OTP?
          <vue-countdown v-if="counting" :time="60000" @end="onCountdownEnd" v-slot="{ totalSeconds }">make new
            <strong>{{
                totalSeconds
            }}</strong> after seconds
          </vue-countdown>
          <span v-else>make new request</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import VueCountdown from "@chenfengyuan/vue-countdown";
import store from "@/store"
export default {
  components: {
    VueCountdown,
  },

  data: () => ({
    otp: null,
    loading: false,
    counting: false,
    error: null,
    snackbar: false,
    errorMessage: "",
    timeout: 3500,
    // error: false,
  }),
  methods: {
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
    },

    async requestNewOtp() {
      const token = store.getters["auth/otp_permission"];
      console.log(token);
    },
    async submit() {
      /**
       * to verify the user account get the access token the store or local storage
       * and send it to the server  alongside the otp sent to the user to verify the user account
       */
      this.loading = true;
      const { otp } = this;
      const token = store.getters["auth/otp_permission"];
      try {
        const { data: response } =
          await axios.post("/auth/forgotten-password/verify-otp",
            { otp },
            {
              headers: { 'Authorization': `Bearer ${token}` }
            });
        console.log(JSON.stringify(response));
        //stop the loading once there is a response
        if (response) this.loading = false;
        if (response.success) {
          this.message = response.message;
          this.snackbar = true;
          localStorage.removeItem("access_token");
          window.setTimeout(() => {
            this.$router.replace({ name: 'reset-password' });
          }, 2000);
          return;
        }
      }
      catch (error) {
        this.loading = false
        this.error = true
        this.errorMessage = error.response.data.message;
        this.snackbar = true;
        this.response = error.response.data;
      }
    },
  },
};
</script>

<style>
</style>








